import { render, staticRenderFns } from "./TopnPieChart.vue?vue&type=template&id=1dfe2866&"
import script from "./TopnPieChart.vue?vue&type=script&lang=js&"
export * from "./TopnPieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports